import {
	collection,
	getDocs,
	query,
	where
} from "firebase/firestore";

import { db } from "./firebaseConfig";

export default async function obtenerProgresoUsuario(userId) {

	try {

		const q = query(
			collection(db, "progreso_metas"),
			where("userId", "==", userId)
		);

		const snap = await getDocs(q);

		if (snap.empty) {

			console.log("No existe progreso");

			return null;
		}

		let total = {

			xpActual: 0,
			xpMax: 100,

			streak: 0,

			multiplier: 1,

			corrupcion: 0,

			nivel: 1,

			xpTotal: 0,

			yutokens: 0,

			rankedLp: 0,

			rankedRango: "Hierro",

			preguntas_correctas: 0,
			preguntas_respondidas: 0
		};

		snap.forEach((docu) => {

			const data = docu.data();

			total.xpActual =
				Math.max(
					total.xpActual,
					data.xp || 0
				);

			total.xpMax =
				Math.max(
					total.xpMax,
					data.xp_siguiente_nivel || 100
				);

			total.streak =
				Math.max(
					total.streak,
					data.streak_actual || 0
				);

			total.corrupcion =
				Math.max(
					total.corrupcion,
					data.corrupcion || 0
				);

			total.nivel =
				Math.max(
					total.nivel,
					data.nivel || 1
				);

			total.xpTotal +=
				data.xp || 0;

			total.yutokens +=
				data.yutokens || 0;

			total.rankedLp =
				Math.max(
					total.rankedLp,
					data.rankedLp || 0
				);

			total.rankedRango =
				data.rankedRango || "Hierro";

			total.preguntas_correctas +=
				data.preguntas_correctas || 0;

			total.preguntas_respondidas +=
				data.preguntas_respondidas || 0;
		});

		total.precision =
			total.preguntas_respondidas > 0
				? Math.round(
					(total.preguntas_correctas /
						total.preguntas_respondidas) * 100
				)
				: 0;

		return total;

	} catch (error) {

		console.error(
			"Error obteniendo progreso:",
			error
		);

		return null;
	}
}